import { env } from '~/env';

export const isLatamEnv = env.runtimeConfig.id === 'env.localprod.latam';
